var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrilanka(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68751e-05 2.08698H0V21.913H4.68751e-05V12.0001V2.08698Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39137 2.08698H5.2366C5.05247 2.21283 4.87229 2.34385 4.69571 2.47946L3.65222 12L4.69571 21.5205C4.87229 21.6562 5.05247 21.7872 5.2366 21.913H9.39137V2.08698Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 12.0001C6.10352e-05 15.8787 1.84075 19.327 4.69573 21.5206V2.47949C1.84075 4.67315 6.10352e-05 8.12138 6.10352e-05 12.0001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3044 7.31552V7.61576L19.3155 7.61744L19.3044 7.31552Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0436 15.1304H20.7827L19.8262 16.1739V18.2609H17.7392V17.2174H18.7827V15.1304H14.087V16.4348H13.0435V13.949C12.7234 13.6624 12.5218 13.2461 12.5218 12.7826V6.00001C12.5218 5.13559 13.2226 4.43481 14.087 4.43481V14.087H16.174L16.8901 13.4902C16.765 13.1923 16.6957 12.8652 16.6957 12.5218V10.9566H15.1305V7.82617H18.2609C18.2609 7.30445 19.0435 6.78269 19.0435 6.78269C19.0435 6.78269 19.8262 7.30441 19.8262 7.82617V8.6088V10.9566C20.4066 10.9635 21.3288 10.9485 22.3252 10.9566C22.0634 10.4991 21.9131 9.95627 21.9131 9.39143C21.9131 8.47075 22.3106 7.64303 22.9433 7.07022C22.0313 5.0492 20.576 3.32598 18.7635 2.08698H10.9566V21.9131H18.7636C20.9676 20.4065 22.6433 18.1841 23.4563 15.5807L23.0436 15.1304Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrilanka);
export default __webpack_public_path__ + "static/media/srilanka.814be61ad958469aecf36deadc2c1566.svg";
export { ForwardRef as ReactComponent };